import { RouteObject } from 'react-router';

import { VisitorsContainer } from './containers/VisitorsContainer';
import { ExportsCreateContainer } from '../exports/containers/ExportsCreateContainer';

const routes: RouteObject[] = [
    {
        path: 'visitors',
        element: <VisitorsContainer />,
        children: [
            {
                path: 'create',
                element: <ExportsCreateContainer />,
            },
        ],
    },
];

export default routes;
